import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchAsyncGetAutomatedBank } from "redux/embrillProfileSlice";

const usePaidByDetails = (accountUser) => {
    const dispatch = useDispatch();

    const [senderData, setSenderData] = useState({
      aggrId: "",
      aggrName: "",
      corpId: "",
      userId: accountUser?.useId,
      urn: "",
      debitAcc: "",
    });
    const [isLoading, setIsLoading] = useState(false);
  
    const fetchPaidByDetails = useCallback(() => {
      setIsLoading(true);
      
      dispatch(fetchAsyncGetAutomatedBank())
        .then((res) => {
          setIsLoading(false);
          if (res?.payload?._id) {
            const data = res.payload;
            setSenderData(prev => ({
              ...prev,
              aggrId: data.aggId,
              aggrName: data.aggName,
              corpId: data.corId,
              urn: data.urn,
              debitAcc: data.bnk?.acNo,
            }));
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
    }, [dispatch]);
  
    useEffect(() => {
      fetchPaidByDetails();
    }, []);
  
    return { senderData };
  };

  export default usePaidByDetails